import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, GraduationCap, Newspaper, HelpCircle, LogOut, ExternalLink } from "lucide-react";
import { useAuth } from "./AuthContext";
import "./Admin.css";
export default function AdminLayout() {
  const { admin, logout } = useAuth();
  const navigate = useNavigate();
  function handleLogout() {
    logout();
    navigate("/admin/login", { replace: true });
  }
  return (
    <div className="admin">
      <div className="admin-shell">
        <aside className="admin-sidebar">
          <div>
            <div className="admin-sidebar__brand">What Next</div>
            <div className="admin-sidebar__sub">Admin Panel</div>
          </div>
          <nav className="admin-nav">
            <NavLink to="/admin" end className={({ isActive }) => (isActive ? "active" : "")}>
              <LayoutDashboard size={16} /> Dashboard
            </NavLink>
            <NavLink to="/admin/courses" className={({ isActive }) => (isActive ? "active" : "")}>
              <GraduationCap size={16} /> Courses
            </NavLink>
            <NavLink to="/admin/blogs" className={({ isActive }) => (isActive ? "active" : "")}>
              <Newspaper size={16} /> Blog Posts
            </NavLink>
            <NavLink to="/admin/faqs" className={({ isActive }) => (isActive ? "active" : "")}>
              <HelpCircle size={16} /> FAQs
            </NavLink>
            <a href="/" target="_blank" rel="noreferrer">
              <ExternalLink size={16} /> View Site
            </a>
          </nav>
          <div className="admin-sidebar__footer">
            <div>{admin?.name}</div>
            <div style={{ opacity: 0.7, wordBreak: "break-all" }}>{admin?.email}</div>
            <button className="admin-btn admin-btn--outline admin-btn--sm" onClick={handleLogout}>
              <LogOut size={14} /> Log out
            </button>
          </div>
        </aside>
        <main className="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}